import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useAnnouncementsQueryCache } from '@web/announcements/hooks/useAnnouncementsQueryCache';

export const useMarkAnnouncementAsRead = () => {
  const { markAnnouncementAsRead } = useAnnouncementsQueryCache();
  const { announcements } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: ID) => announcements.read(payload),
    onSuccess: (result, payload) => {
      markAnnouncementAsRead(payload);
    },
  });

  return mutation;
};
